import {Space} from "antd";
import Logo from "./Graphics/Logo";
import {DoubleLine} from "./Labels";
import React from "react";
import {stringMixin} from "../utils/strings";

const TickerChip = ({ticker, additionalItems, fontColor='#000', noGap=false,
                        imgSize=32, titleSize=14, textSize=11,
                        titleSuffix=''
                    })=>{
    return (
        <Space style={{width: '300px'}}>
            <Logo src={ticker?.logo} height={imgSize} width={imgSize} borderRadius={'4px'} />
            <DoubleLine title={`${ticker?.symbol?.toUpperCase?.()??''} ${titleSuffix}`}
                        text={stringMixin.fmt(ticker?.name)}
                        maxLength={30}
                        titleSize={titleSize}
                        textSize={textSize}
                        textWeight={'600'}
                        fontColor={fontColor}
                        noGap={noGap}

            />
            {additionalItems}
        </Space>
    )
}

export default TickerChip;